import { lazy } from 'react'

// routes.js
export const routes = [
    {
        key: 'index',
        path: '/',
        component: lazy(() => import('@pages/HomePage')),
    },
    {
        key: 'home',
        path: '/home',
        component: lazy(() => import('@pages/HomePage')),
    },
    {
        key: 'product',
        path: '/product/:seriesCode?/:productId?',
        component: lazy(() => import('@pages/ProductPage')),
    },
    {
        key: 'contact',
        path: '/contact',
        component: lazy(() => import('@pages/ContactPage')),
    },
    {
        key: 'company',
        path: '/company',
        component: lazy(() => import('@pages/CompanyPage')),
    },
    {
        key: 'case_show',
        path: 'case_show/:caseId?',
        component: lazy(() => import('@pages/CaseShowPage')),
    },
    {
        key: 'news_center',
        path: 'news_center/:tab?/:newsId?',
        component: lazy(() => import('@pages/NewsCenterPage')),
    }
];